// extracted by mini-css-extract-plugin
export default {"results-card-header":"Results_results-card-header__nlinC","results-count":"Results_results-count__8tKD9"};